import { render, staticRenderFns } from "./HistoryPage.vue?vue&type=template&id=608cc9ee&scoped=true"
import script from "./HistoryPage.vue?vue&type=script&lang=js"
export * from "./HistoryPage.vue?vue&type=script&lang=js"
import style0 from "./HistoryPage.vue?vue&type=style&index=0&id=608cc9ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608cc9ee",
  null
  
)

export default component.exports